export default __webpack_public_path__ + "static/media/A1TechGroup.cdf9b963.jpg";